import fetchAPI from '../utils/fetchAPI';

export default ({ xsrfToken, sellerId }: { xsrfToken: string; sellerId: number }) =>
  fetchAPI({
    method: 'POST',
    url: `/smb-profile/api/favoritesellers/${sellerId}`,
    xsrfToken,
  });
